export default "__VITE_ASSET__CyGdkzbT__"